module.exports = __webpack_public_path__ + "static/home-search-form-back-4-ba26e63682d8dc755a39d891df4dbd77.png";